<script>
export default {
	name: 'IconSvg7z',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_66_315)">
				<path
					d="M13.4781 4.104C13.0134 4.10333 12.5678 3.92198 12.2392 3.5997C11.9107 3.27743 11.7259 2.84055 11.7254 2.3849V0H3.89355C3.28691 0 2.70511 0.236249 2.27615 0.656782C1.84719 1.07731 1.6062 1.64769 1.6062 2.24241V15.7602C1.6071 16.3543 1.84849 16.9238 2.27735 17.3436C2.70621 17.7635 3.28749 17.9993 3.89355 17.9992H13.2954C13.9015 17.9993 14.4827 17.7635 14.9116 17.3436C15.3405 16.9238 15.5818 16.3543 15.5827 15.7602V4.104H13.4781Z"
					:fill="color" />
				<path
					d="M15.5828 4.104H13.4782C13.0134 4.10333 12.5678 3.92198 12.2393 3.5997C11.9107 3.27743 11.7259 2.84055 11.7255 2.3849V0L15.5828 4.104Z"
					fill="#FFBC00" />
				<path
					d="M17.2411 14.2169H6.61266C5.85873 14.2169 5.24756 14.8161 5.24756 15.5552V18.6617C5.24756 19.4008 5.85873 20 6.61266 20H17.2411C17.995 20 18.6062 19.4008 18.6062 18.6617V15.5552C18.6062 14.8161 17.995 14.2169 17.2411 14.2169Z"
					fill="#FFBC00" />
				<path d="M10.187 17.7682V18.374H9.547V17.7682H10.187Z" fill="#F3F3F6" />
				<path
					d="M10.6329 18.3698L11.6699 16.3179V16.3008H10.4619V15.8684H12.217V16.3069L11.1789 18.3698H10.6329Z"
					fill="#F3F3F6" />
				<path
					d="M13.1789 17.8595H14.3068V18.3486H12.4921V17.8878L13.6022 16.3287H12.5065V15.8429H14.3V16.3037L13.1789 17.8595Z"
					fill="#F3F3F6" />
				<path
					d="M8.5933 12.7095C8.30744 12.7091 8.03343 12.5975 7.83138 12.3993C7.62933 12.201 7.51573 11.9323 7.5155 11.6521V10.5946H9.67195V11.6521C9.67173 11.9324 9.55801 12.2013 9.35577 12.3996C9.15353 12.5978 8.87931 12.7093 8.5933 12.7095ZM8.06715 11.1354V11.6521C8.06715 11.7889 8.12256 11.9202 8.2212 12.0171C8.31985 12.114 8.45368 12.1685 8.5933 12.1687C8.733 12.1685 8.86691 12.114 8.9657 12.0171C9.06448 11.9203 9.12007 11.789 9.1203 11.6521V11.1354H8.06715Z"
					fill="#FFBC00" />
				<path d="M7.51438 10.5955H8.59558V9.5355H7.51438V10.5955Z" fill="#FFBC00" />
				<path d="M8.59324 9.53625H9.67444V8.4763H8.59324V9.53625Z" fill="#FFBC00" />
				<path d="M7.51438 8.47717H8.59558V7.41722H7.51438V8.47717Z" fill="#FFBC00" />
				<path d="M8.59324 7.41797H9.67444V6.35802H8.59324V7.41797Z" fill="#FFBC00" />
			</g>
			<defs>
				<clipPath id="clip0_66_315">
					<rect width="20" height="20" fill="white" transform="translate(0.106201)" />
				</clipPath>
			</defs>
		</svg>
	</div>

</template>

<style scoped>

</style>